import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { ShieldCheck, LogOut, Phone, Mail, Lock } from "lucide-react";
import { usePortalAuth } from "../../context/PortalAuthContext";

export default function PortalShell({ children, showNav = true }) {
  const { customer, logout } = usePortalAuth();
  const navigate = useNavigate();

  return (
    <div className="min-h-screen flex flex-col" style={{ background: "var(--te-bg)" }}>
      <header
        className="border-b border-white/10 sticky top-0 z-30"
        style={{ background: "rgba(5,5,5,0.85)", backdropFilter: "blur(20px)" }}
      >
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between gap-3">
          <Link to="/portal" className="flex items-center gap-2 group">
            <div
              className="w-8 h-8 flex items-center justify-center"
              style={{ background: "var(--te-primary)" }}
            >
              <ShieldCheck size={16} color="#fff" strokeWidth={2.5} />
            </div>
            <div className="leading-tight">
              <div className="text-sm font-extrabold tracking-tight text-white">
                TECH EMERGENCY
              </div>
              <div className="text-[9px] tracking-[0.22em] font-semibold uppercase text-zinc-500">
                Customer Portal
              </div>
            </div>
          </Link>

          {showNav && customer && (
            <div className="flex items-center gap-3">
              <span className="text-xs text-zinc-400 hidden sm:block truncate max-w-[160px]">
                {customer.email}
              </span>
              <Link
                to="/portal/security"
                data-testid="portal-security-link"
                className="te-btn te-btn-ghost text-xs"
                title="2FA &amp; security"
              >
                <Lock size={12} /> <span className="hidden sm:inline">Security</span>
              </Link>
              <button
                type="button"
                onClick={() => {
                  logout();
                  navigate("/portal/login");
                }}
                data-testid="portal-logout"
                className="te-btn te-btn-ghost text-xs"
              >
                <LogOut size={12} /> Sign out
              </button>
            </div>
          )}
        </div>
      </header>

      <main className="flex-1">{children}</main>

      <footer className="border-t border-white/10 mt-8">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-6 flex flex-col sm:flex-row items-center justify-between gap-3 text-[11px] text-zinc-500">
          <div>© Tech Emergency · Adelaide Mobile IT</div>
          <div className="flex items-center gap-4">
            <a
              href="tel:1800836390"
              className="inline-flex items-center gap-1.5 hover:text-white transition"
            >
              <Phone size={11} /> 1800 836 390
            </a>
            <a
              href="mailto:bookings@techemergency.com.au"
              className="inline-flex items-center gap-1.5 hover:text-white transition"
            >
              <Mail size={11} /> Contact
            </a>
          </div>
        </div>
      </footer>
    </div>
  );
}
